import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

type RemoveImportMethodParams = {
	importId: string;
};

export default function useDeleteImportMethod(shop: ShopDto) {
	return useApiMutation("delete", "/shops/{shopId}/imports/{importId}", {
		invalidate: useInvalidateShop(shop.id),
		mapVariables: ({ importId }: RemoveImportMethodParams) => ({
			params: { path: { importId, shopId: shop.id } },
		}),
	});
}
